"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _Icon = _interopRequireDefault(require("../Icon"));
var _Tabs = require("./Tabs.styles");
const Tabs = _ref => {
  let {
    className = 'tabs',
    type,
    items = [],
    onClick,
    fit = 'medium'
  } = _ref;
  // internal state for overflow scrolls
  const [width, setWidth] = (0, _react.useState)(0);
  const [prevButtonDisabled, setPrevButtonDisabled] = (0, _react.useState)(false);
  const [nextButtonDisabled, setNextButtonDisabled] = (0, _react.useState)(false);
  let scrollPos = 0;
  // ref for unorderedList
  const unorderedListRef = (0, _react.useRef)(null);
  (0, _react.useLayoutEffect)(() => {
    if (null !== unorderedListRef.current) {
      setWidth(unorderedListRef.current.scrollWidth);
      setNextButtonDisabled(scrollPos >= unorderedListRef.current.scrollWidth || unorderedListRef.current.scrollWidth <= window.innerWidth - 100);
    }
    setPrevButtonDisabled(scrollPos === 0);
  }, []);
  (0, _react.useEffect)(() => {
    if (type === 'overflow') {
      setTimeout(() => {
        const activeElement = document.querySelector('li.active');
        if (activeElement) {
          activeElement.scrollIntoView();
        }
      }, 100);
    }
  }, []);
  /**
   * @name onTabsClick
   * @param selectedItem
   * @description
   * Callback with an Object that contains the Selected Tab, and updated Array of Objects with the appropriate active item
   * {
   *  selectedItemId: 'case',
   *  updatedTabData: [{ 'title':'Comments','id':'comments','active':true }, ...]
   * }
   * @returns none
   */
  const onTabsClick = selectedItem => {
    const updatedTabData = {
      selectedItemId: selectedItem.id,
      updatedTabData: items.map(item => {
        return (0, _extends2["default"])((0, _extends2["default"])({}, item), {
          active: item.id === selectedItem.id ? true : false
        });
      })
    };
    if (typeof onClick === 'function') {
      onClick(updatedTabData);
    }
  };
  /**
   * @name isPreviousButtonDisabled
   * @description checks the scroll position and returns if the previous button is disabled or not
   * @returns scrollPos
   */
  const isPreviousButtonDisabled = () => {
    return scrollPos === 0;
  };
  /**
   * @name isNextButtonDisabled
   * @description checks the scroll position and returns if the next button is disabled or not
   * @returns scrollPos
   */
  const isNextButtonDisabled = () => {
    return scrollPos >= width;
  };
  /**
   * @name handlePreviousClick
   * @description checks the scroll position and scrolls the items with smooth effect on click of previous buttton
   * @returns scrollPos
   */
  const handlePreviousClick = () => {
    var _a;
    scrollPos -= 100;
    if (scrollPos < 0) {
      scrollPos = 0;
    }
    (_a = unorderedListRef === null || unorderedListRef === void 0 ? void 0 : unorderedListRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
      behavior: 'smooth',
      left: scrollPos
    });
    setPrevButtonDisabled(isPreviousButtonDisabled());
    setNextButtonDisabled(isNextButtonDisabled());
  };
  /**
   * @name handleNextClick
   * @description checks the scroll position and scrolls the items with smooth effect on click of next buttton
   * @returns scrollPos
   */
  const handleNextClick = () => {
    var _a;
    scrollPos += 100;
    (_a = unorderedListRef === null || unorderedListRef === void 0 ? void 0 : unorderedListRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
      behavior: 'smooth',
      left: scrollPos
    });
    setPrevButtonDisabled(isPreviousButtonDisabled());
    setNextButtonDisabled(isNextButtonDisabled());
  };
  // JSX for the List of Items
  const getListOfItems = () => {
    return (0, _jsxRuntime.jsx)(_Tabs.Components.UnorderedList, (0, _extends2["default"])({
      ref: unorderedListRef,
      type: type
    }, {
      children: items.map((item, index) => {
        return (0, _jsxRuntime.jsx)(_Tabs.Components.ListItem, (0, _extends2["default"])({
          type: type,
          onClick: () => onTabsClick(item),
          className: item.active ? 'active' : ''
        }, {
          children: (0, _jsxRuntime.jsxs)(_Tabs.Components.ListItemButton, (0, _extends2["default"])({
            fit: fit
          }, {
            children: [item.icon && (0, _jsxRuntime.jsx)(_Icon["default"], {
              name: item.icon,
              size: ['small', 'medium'].includes(fit) ? '20' : '24'
            }), (0, _jsxRuntime.jsx)(_Tabs.Components.ListItemButtonTitle, (0, _extends2["default"])({
              fit: fit
            }, {
              children: item.title
            }))]
          }))
        }), "".concat(item.id, "-").concat(index));
      })
    }));
  };
  // JSX for Tabs
  return (0, _jsxRuntime.jsx)(_Tabs.Components.Nav, (0, _extends2["default"])({
    className: className
  }, {
    children: (0, _jsxRuntime.jsxs)(_Tabs.Components.TabsWrapper, {
      children: [type === 'overflow' ? (0, _jsxRuntime.jsx)(_Tabs.Components.ButtonLeftRight, (0, _extends2["default"])({
        onClick: () => handlePreviousClick(),
        disabled: prevButtonDisabled
      }, {
        children: (0, _jsxRuntime.jsx)(_Icon["default"], {
          name: "chevron-left"
        })
      })) : '', items.length > 0 ? getListOfItems() : '', type === 'overflow' ? (0, _jsxRuntime.jsx)(_Tabs.Components.ButtonLeftRight, (0, _extends2["default"])({
        onClick: () => handleNextClick(),
        disabled: nextButtonDisabled
      }, {
        children: (0, _jsxRuntime.jsx)(_Icon["default"], {
          name: "chevron-right"
        })
      })) : '']
    })
  }));
};
var _default = exports["default"] = Tabs;